import registerRoutes from './routes';
import loginScreens from './main/partials-js/loginScreens';
import onlineFormResponse from './main/partials-js/onlineFormResponse';
import vehicleDetailsModal from './main/partials-js/vehicleDetailsModal';
import letterComposingModal from './main/partials-js/letterComposingModal';
import typography from './main/partials-js/typography';
import tabsV1 from './main/partials-js/tabsV1';
import taskCardsPullOut from './main/partials-js/taskCardsPullOut';
import accordion from './main/partials-js/accordion';
import tagsSection from './main/partials-js/tagsSection';

export default function (app) {
    registerRoutes(app);

    app.directive('loginScreens', loginScreens);
    app.directive('onlineFormResponse', onlineFormResponse);
    app.directive('vehicleDetailsModal', vehicleDetailsModal);
    app.directive('letterComposingModal', letterComposingModal);
    app.directive('typography', typography);
    app.directive('tabsV1', tabsV1);
    app.directive('taskCardsPullOut', taskCardsPullOut);
    app.directive('accordion', accordion);
    app.directive('tagsSection', tagsSection);
}



// WEBPACK FOOTER //
// ./Client/app/sink/index.js